import cardTypeCheckers from 'types/cardTypeCheckers';
import visTypeCheckers from 'types/visTypeCheckers';

// Cards only reference their gadget by id, so look the gadget up to find its
// definition type.
const getUsesGroupVsRemainderVis = ({
  canvas,
  dashboardGadgetsLookup,
  reportGadgetsLookup,
}: {
  canvas: Canvas;
  dashboardGadgetsLookup: { [id: string]: DashboardGadget | undefined };
  reportGadgetsLookup: {
    [id: string]: ReportGadgets.ReportGadget | undefined;
  };
}) =>
  canvas.cards.some((c) => {
    if (cardTypeCheckers.isDashboardGadget(c)) {
      const gadget = dashboardGadgetsLookup[c.content.dashboardGadgetId];
      return visTypeCheckers.isGroupVsRemainder(gadget?.chartDef);
    }
    if (cardTypeCheckers.isReportGadget(c)) {
      const gadget = reportGadgetsLookup[c.content.reportGadgetId];
      return visTypeCheckers.isGroupVsRemainder(gadget?.chartDef);
    }
    return false;
  });

export default getUsesGroupVsRemainderVis;
